import React, { Component} from 'react';

export default class Button extends Component{
    constructor(props){
        super(props);
    }
    componentDidMount(){

    }

    render(){

        const { cName, title, id } = this.props;
        
        return(
            <div className={ cName } id={id} data-role="Widget">
                <div className="word">
                    { title }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/button.js